import styles from './RecommendationPage.module.scss';
import { ChangeEvent } from 'react';
import AccordionArrowIcon from 'components/icons/AccordionArrowIcon';

type FilterFieldProps = {
  title: string;
  name: string;
  options: string[];
  active: string[];
  onChange: (e: ChangeEvent<HTMLFormElement>) => void;
  formatLabel?: (value: string) => string;
};

const FilterField = ({
  title,
  name,
  options,
  active,
  onChange,
  formatLabel,
}: FilterFieldProps) => {
  return (
    <details open className={styles.filter}>
      <summary>
        <span>{title}</span>
        <span className={styles.arrow}>
          <AccordionArrowIcon direction="up" size="small" />
        </span>
      </summary>

      <form onChange={onChange} className={styles.checkboxForm}>
        <ul>
          {options.map((value, idx) => (
            <li key={idx}>
              <label>
                <input
                  type="checkbox"
                  name={name}
                  value={value}
                  checked={active.includes(value)}
                  onChange={() => {}}
                />
                <span>{formatLabel ? formatLabel(value) : value}</span>
              </label>
            </li>
          ))}
        </ul>
      </form>
    </details>
  );
};

export default FilterField;
